import { render, staticRenderFns } from "./WidgetFAQ.vue?vue&type=template&id=30d5e148&"
import script from "./WidgetFAQ.vue?vue&type=script&lang=js&"
export * from "./WidgetFAQ.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFAQ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports